import { Center, Spinner, useUpdateEffect } from '@chakra-ui/react';
import ServiceProductsGrid from 'presentation/components/modules/products/grid/ServiceProductsGrid';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useFetchServiceProductListQuery } from 'rtkQuery/sharespro/queries/services';

const ServiceProductsPage: FC = () => {
  const { t, i18n } = useTranslation();

  const { isFetching, data, error, refetch } = useFetchServiceProductListQuery();

  useUpdateEffect(() => {
    refetch();
  }, [i18n.language]);

  let content;
  let hasData = false;
  if (data) {
    content = <ServiceProductsGrid items={data} />;
    hasData = true;
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (!hasData) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <ActivesPageLayout>
      <Helmet>
        <title>{t('productsTitle')}</title>
      </Helmet>
      {content}
    </ActivesPageLayout>
  );
};

export default ServiceProductsPage;
